// extracted by mini-css-extract-plugin
export default {"form":"styles_form__b0T8s"};